import {
  Box,
  Divider,
  FormGroup,
  Typography,
  TypographyProps,
} from "@mui/material";
import { styled } from "@mui/system";
import { PropsWithChildren } from "react";
import AddButton, {
  AddButtonProps,
} from "../../../common/components/functional/addButton/AddButton";
import { CustomButton } from "../../../common/components/functional/customButton/CustomButton";
import FormSection, {
  FormSectionProps,
} from "../../../common/components/functional/formSection/FormSection";
import ModalComponent from "../../../common/components/functional/modalComponent";
import { ModalComponentProps } from "../../../common/components/functional/modalComponent/ModalComponent";
import { Trans } from "react-i18next/TransWithoutContext";

export const StyledFormSection = (props: FormSectionProps) => {
  return (
    <FormSection
      headerSx={{
        marginBottom: "0.5rem",
      }}
      {...props}
    />
  );
};

export const AddPricingButton = (props: AddButtonProps) => {
  return (
    <AddButton
      sx={{
        margin: "1em",
        fontSize: "16px",
        height: "42px",
        borderRadius: "20px",
        paddingLeft: "1.2em",
        paddingRight: "1.2em",
      }}
      {...props}
    />
  );
};

export const StyledFormGroup = styled(FormGroup)({
  background: "white",
  borderRadius: "12px",
  padding: "1em",
  flexWrap: "nowrap",
  overflowY: "auto",
  cursor: "auto",
});

export const EditPricingButton = styled(CustomButton)({
  minWidth: 0,
  width: "32px",
  marginLeft: "0.5rem",
  paddingLeft: 0,
  paddingRight: 0,
});

export const PricingListSubHeader = styled(Typography)({
  fontFamily: "quicksand",
  fontWeight: "700",
  fontSize: "14px",
  lineHeight: "16.8px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const PricingFormDivider = styled(Divider)({
  width: "100%",
  margin: "1rem 0 1rem 1rem",
});

export const ManagementModal = (
  props: PropsWithChildren<ModalComponentProps>,
) => {
  return (
    <ModalComponent
      sx={{
        backgroundColor: "#EAEAF1",
        display: "flex",
        minWidth: "fit-content",
        maxWidth: "963px",
        minHeight: "fit-content",
        maxHeight: "calc(100% - 40px)",
        borderRadius: "12px",
        padding: "1em",
      }}
      {...props}
    />
  );
};

export const PricingGuideText = (props: TypographyProps) => {
  return (
    <Box fontSize={14} padding="1rem" {...props}>
      <Trans {...props} />
    </Box>
  );
};
